import { useMemo } from 'react';
import styled from 'styled-components';
import { VisuallyHidden } from '../visually_hidden/visually_hidden.component';

const elements = {
	container: styled.div<{ color: string; font: string }>`
		display: flex;

		${({ color }) => `color: ${color};`}
		${({ font }) => `font: ${font};`}
	`,
	startPart: styled.span`
		white-space: pre;
		overflow: hidden;
		text-overflow: ellipsis;
	`,
};

export interface FileNameProps {
	name: string;
	color: string;
	font: string;
}

/**
 * Returns a truncated file name (if parent DOM width is too small)
 */
export function FileName({ name, font, color }: FileNameProps): JSX.Element {
	const [start, end] = useMemo(() => {
		// We want the CSS ellipsis to look like, given the value
		// "abcdefghijklmnopqrstuvwx.jpg", "abc... yz.jpg" instead of "abc....jpg" so
		// we split the name 6 from the end.
		const splitIndex = name.length > 6 ? 6 : 0;
		const start = name.slice(0, name.length - splitIndex);
		const end = splitIndex !== 0 ? name.slice(-splitIndex) : null;

		return [start, end];
	}, [name]);

	return (
		<elements.container font={font} color={color}>
			<elements.startPart aria-hidden>{start}</elements.startPart>
			<span aria-hidden>{end}</span>
			<VisuallyHidden>{name}</VisuallyHidden>
		</elements.container>
	);
}
